Chiffres = {
	init : ->
		console.log 'Chiffres init'
		@chartsManager()


	chartsManager : ->
		_this = @

		# Unregister global datalabels
		Chart.plugins.unregister(ChartDataLabels);
		@createChartEvolutionCA()
		
		if Config.isMobile()
			@createChartRepartitionCA()
			@createChartEffectif()
			
			

		# Tabs manager
		if Config.isMobile()
			$('.tab--header-mobile').on "click", (ev) ->
				container = $(@).parent()
				content = container.find('.tab--content')
				if container.hasClass 'open'
					container.removeClass 'open'
					TweenLite.to content, 0.4, {height: 0, ease:Quint.easeOut}
				else
					container.addClass 'open'
					TweenLite.set content, {height: 'auto'}
					TweenLite.from content, 0.4, {height: 0, ease:Quint.easeOut}
		else
			$('.tabs--list li').on 'click', (ev) ->
				
				if not $(@).hasClass 'selected'
					# switch selected tab header
					$('.tabs--list li').removeClass 'selected'
					$(@).addClass 'selected'

					# save current tab
					currentTab = $('.tab.selected') 
					# retrieve target
					targetId = $(@).attr 'data-show'
					target = $('#'+targetId)
					
					# switch selected tab
					tlSwitchTab = new TimelineLite
					tlSwitchTab.addLabel 'start'
					tlSwitchTab.fromTo currentTab.find('.markup'), 0.4, {autoAlpha:1, x:0, ease:Quint.easeIn}, {autoAlpha:0, x:20, ease:Expo.easeOut}, 'start',
					tlSwitchTab.fromTo currentTab.find('canvas'), 0.4, {autoAlpha:1}, {autoAlpha:0, ease:Quint.easeIn}, 'start',
					tlSwitchTab.call switchSelectedTab, [currentTab, target], null, 'start+=0.4'
					tlSwitchTab.fromTo target.find('.markup'), 0.4, {autoAlpha:0, x:-20}, {autoAlpha:1, x:0, ease:Quint.easeOut}
		
		switchSelectedTab = (current, next) =>
			current.removeClass 'selected'
			next.addClass 'selected'
			TweenLite.set $('.tab canvas'), {autoAlpha:1}
			switch next.attr 'id'
				when 'tab_evolution' then _this.createChartEvolutionCA()
				when 'tab_repartition' then _this.createChartRepartitionCA()
				when 'tab_effectif' then _this.createChartEffectif()
			# Empty old canvas
			canvas = current.find('canvas')[0]
			context = canvas.getContext('2d')
			context.clearRect(0, 0, canvas.width, canvas.height)
			context.beginPath()

	createChartEvolutionCA : ->
		# get context
		ctxEvolution = document.getElementById("chart_evolution").getContext('2d');
		# retrieve data
		labels = []
		values = []
		
		if Config.isMobile()
			data = $('#chart_evolution .data:not(.not-mobile)')
		else
			data = $('#chart_evolution .data')

		$.each data, (i, elt) ->
			labels.push $(elt).attr 'data-label'
			values.push $(elt).attr 'data-value'

		# create chart
		chartEvoCa = new Chart(ctxEvolution, {
			type: 'bar',
			plugins: [ChartDataLabels],
			data: {
				labels: labels
				datasets: [{
					data: values,
					backgroundColor: 'rgb(62,121,238,1)',	
					borderWidth: 0,
					datalabels: {
						color: '#fff',
						fontStyle: 'bold',
						rotation: -90,
						anchor: 'start',
						align: 'top',
						offset: 10,
						font: {
							style: 'bold',
							size: 14
						},
						formatter: (value, context) ->
							return value + ' M€'
					}
				}]
			},
			options: {
				legend: {display: false},
				tooltips: {enabled: false},
				hover: {mode: null},
				scales: {
					xAxes: [{
						ticks: {
							fontSize: 16,
							fontStyle: 'bold',
							fontColor: '#003949'
						}
						gridLines: {color:'rgba(255,255,255,0)'}
					}]
					yAxes: [{
						display: false,
						ticks : {beginAtZero: true}
						gridLines: {color:'rgba(255,255,255,0)'}
					}]
				},
			}
		})

	createChartRepartitionCA : ->
		# get context
		ctxRepartition = document.getElementById("chart_repartition").getContext('2d');
		# retrieve data
		labels = []
		values = []
		$.each $('#chart_repartition .data'), (i, elt) ->
			labels.push $(elt).attr 'data-label'
			values.push $(elt).attr 'data-value'

		# create chart
		if Config.isMobile()
			chartEvoCa = new Chart(ctxRepartition, {
				type: 'pie',
				data: {
					labels: labels,
					datasets: [{
						data: values,
						backgroundColor: ['rgba(62,121,238,1)', 'rgba(42,100,210,1)', 'rgba(25,89,176,1)', 'rgba(7,64,131,1)', 'rgba(8,64,89,1)', 'rgba(0,57,74,1)'],	
						borderColor: ['rgba(62,121,238,1)', 'rgba(42,100,210,1)', 'rgba(25,89,176,1)', 'rgba(7,64,131,1)', 'rgba(8,64,89,1)', 'rgba(0,57,74,1)'],	
						# borderWidth: 0,
						hoverBackgroundColor: 'rgb(62,121,238,1)',
					}]
				},
				options: {
					# tooltips: {enabled: false},
					# hover: {mode: null},
					legend: {display: false}
				}
			})
		else
			chartEvoCa = new Chart(ctxRepartition, {
				type: 'pie',
				data: {
					labels: labels,
					datasets: [{
						data: values,
						backgroundColor: ['rgba(62,121,238,1)', 'rgba(42,100,210,1)', 'rgba(25,89,176,1)', 'rgba(7,64,131,1)', 'rgba(8,64,89,1)', 'rgba(0,57,74,1)'],	
						borderColor: ['rgba(62,121,238,1)', 'rgba(42,100,210,1)', 'rgba(25,89,176,1)', 'rgba(7,64,131,1)', 'rgba(8,64,89,1)', 'rgba(0,57,74,1)'],	
						# borderWidth: 0,
						hoverBackgroundColor: 'rgb(62,121,238,1)',
					}]
				},
				options: {
					tooltips: {enabled: false},
					hover: {mode: null},
					legend: {
						position: 'right',
						fullWidth: false,
						onClick: (e) => e.stopPropagation()
						labels: {
							padding: 20,
							fontStyle: 'bold',
							fontColor: "#000",
							fontSize: 16
							usePointStyle: true
							generateLabels: (chart) ->
								data = chart.data;
								if data.labels.length && data.datasets.length
									return data.labels.map (label, i) ->
										meta = chart.getDatasetMeta(0);
										ds = data.datasets[0];
										arc = meta.data[i];
										custom = arc && arc.custom || {};
										valueAtIndexOrDefault = Chart.helpers.valueAtIndexOrDefault;
										arcOpts = chart.options.elements.arc;
										fill = valueAtIndexOrDefault(ds.backgroundColor, i, arcOpts.backgroundColor);
										stroke = valueAtIndexOrDefault(ds.borderColor, i, arcOpts.borderColor);
										bw = valueAtIndexOrDefault(ds.borderWidth, i, arcOpts.borderWidth);
										value = chart.config.data.datasets[arc._datasetIndex].data[arc._index];
										return {
											text: value + "% " + label,
											fillStyle: fill,
											strokeStyle: stroke,
											lineWidth: bw,
											hidden: isNaN(ds.data[i]) || meta.data[i].hidden,
											index: i
										}
								return [];
						}
					}
				}
			})

	createChartEffectif : ->
		# get context
		ctxEvolution = document.getElementById("chart_effectif").getContext('2d');
		# retrieve data
		labels = []
		values = []

		if Config.isMobile()
			data = $('#chart_effectif .data:not(.not-mobile)')
		else
			data = $('#chart_effectif .data')

		$.each data, (i, elt) ->
			labels.push $(elt).attr 'data-label'
			values.push $(elt).attr 'data-value'

		# create chart
		chartEvoCa = new Chart(ctxEvolution, {
			type: 'bar',
			plugins: [ChartDataLabels],
			data: {
				labels: labels,
				datasets: [{
					data: values,
					backgroundColor: 'rgb(62,121,238,1)',	
					borderWidth: 0,
					datalabels: {
						color: '#fff',
						fontStyle: 'bold',
						rotation: -90,
						anchor: 'start',
						align: 'top',
						offset: 10,
						font: {
							style: 'bold',
							size: 14
						}
					}
				}]
			},
			options: {
				legend: {display: false},
				tooltips: {enabled: false},
				hover: {mode: null},
				scales: {
					xAxes: [{
						ticks: {
							fontSize: 16,
							fontStyle: 'bold',
							fontColor: '#003949'
						}
						gridLines: {color:'rgba(255,255,255,0)'}
					}]
					yAxes: [{
						display: false,
						ticks : {beginAtZero: true}
						gridLines: {color:'rgba(255,255,255,0)'}
					}]
				},
			}
		})


	destroy : ->
		console.log 'Chiffres destroy'
}